import { inject, InjectionToken, Provider } from '@angular/core';
import { TaskDetailSignalState } from '@data-access/tasks/types';
import { TASK_DETAIL_SIGNAL_STORE } from '../signal-store/task-detail.signal-store';
import { TasksDetailFacadeService } from '@data-access/tasks/facade';

const TASK_DETAIL_TOKEN = new InjectionToken<TaskDetailSignalState>(
  'TaskDetail',
);

export function taskDetailTokenizer() {
  return inject(TASK_DETAIL_TOKEN);
}

export const TASK_DETAIL_PROVIDER: Provider = {
  provide: TASK_DETAIL_TOKEN,
  useClass: TASK_DETAIL_SIGNAL_STORE,
};

export const TASK_DETAIL_FACADE_SERVICE =
  new InjectionToken<TasksDetailFacadeService>('TasksDetailFacadeService');
